import { render, staticRenderFns } from "./4mRelationDocu.vue?vue&type=template&id=1e9d97d2"
import script from "./4mRelationDocu.vue?vue&type=script&lang=js"
export * from "./4mRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e9d97d2')) {
      api.createRecord('1e9d97d2', component.options)
    } else {
      api.reload('1e9d97d2', component.options)
    }
    module.hot.accept("./4mRelationDocu.vue?vue&type=template&id=1e9d97d2", function () {
      api.rerender('1e9d97d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/plan/4mRelationDocu.vue"
export default component.exports